<template>

    <div class="row justify-content-center">
        <div class="col-12 col-md-10 col-lg-8">

            <div class="loading" v-if="!b_mounted">{{ trans('crm-loading') }}</div>
            <div class="loading icon" v-if="!b_mounted"></div>

            <form class="bzq-form"
                  v-on:submit="onHandleSubmit"
                  v-bind:class="{'working': b_working}"
            >

                <fieldset v-if="Object.keys(zuordnungenLaender).length">
                    <label for="land">{{ trans('crm-Land') }}</label>
                    <div class="row">
                        <div class="col col-select">
                            <select id="land" name="land" v-model="land">
                                <option v-for="(land) in zuordnungenLaender" :key="land.country_key"
                                        :value="land.country_key">{{ land.country_name }}<template v-if="b_show_sums"> [{{ land._ad_ids_sum }}]</template>
                                </option>
                            </select>
                        </div>
                    </div>
                </fieldset>

                <fieldset v-if="Object.keys(zielgruppen).length">
                    <label>{{ trans('crm-Zielgruppe') }}</label>
                    <div class="row">
                        <div class="col-sm-6 col-radio" v-for="(zielgruppe) in zielgruppen"
                             :key="zielgruppe.zielgruppe_id">
                            <input :id="'zielgruppe-'+zielgruppe.zielgruppe_id" v-model="zielgruppe_id"
                                   :value="zielgruppe.zielgruppe_id"
                                   type="radio" name="zielgruppe"/>
                            <label :for="'zielgruppe-'+zielgruppe.zielgruppe_id"><span>{{
                                    zielgruppe.zielgruppe_bezeichnung
                                }}<template v-if="b_show_sums"> [{{ zielgruppe._ad_ids_sum }}]</template></span></label>
                        </div>
                    </div>
                </fieldset>

                <fieldset v-if="displaySuchinteressen()">
                    <label>{{ trans('crm-Suchinteresse') }}</label>
                    <div class="row">

                        <div class="col-12 col-radio" v-for="(suchinteresse) in suchinteressen"
                             :key="suchinteresse.suchinteresse_id">
                            <input :id="'suchinteresse-'+suchinteresse.suchinteresse_id" v-model="suchinteresse_id"
                                   :value="suchinteresse.suchinteresse_id" type="radio" name="suchinteresse"/>
                            <label class="with-icon" :for="'suchinteresse-'+suchinteresse.suchinteresse_id">
                                <img class="icon" alt="" :src="suchinteresse.suchinteresse_icon_url"/>
                                <span>{{ suchinteresse.suchinteresse_bezeichnung }}<template v-if="b_show_sums"> [{{
                                        suchinteresse._ad_ids_sum
                                    }}]</template></span></label>
                        </div>

                    </div>
                </fieldset>

                <div class="row" v-if="displayBereiche() || displaySerien()">
                    <div class="col-sm-6">
                        <fieldset v-if="displayBereiche()">
                            <label>{{ trans('crm-Produktbereich') }}</label>
                            <div class="row">
                                <div class="col col-select">
                                    <select id="bereich" name="bereich" v-model="bereich_id">
                                        <option v-for="(bereich) in bereiche" :value="bereich.bereich_id"
                                                :key="bereich.bereich_id">{{ bereich.bereich_bezeichnung }}
                                            <template v-if="b_show_sums">[{{ bereich._ad_ids_sum }}]</template>
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </fieldset>
                    </div>
                    <div class="col-sm-6">
                        <fieldset v-if="displaySerien()">
                            <label>{{ trans('crm-SerienSysteme') }}</label>
                            <div class="row">
                                <div class="col col-select">
                                    <select id="serie" name="serie" v-model="serie_id">
                                        <option value="">{{ trans('crm-alle') }}</option>
                                        <option v-for="(serie) in serien" :value="serie.serie_id" :key="serie.serie_id">
                                            {{ serie.serie_bezeichnung }}<template v-if="b_show_sums"> [{{ serie._ad_ids_sum }}]</template>
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </fieldset>
                    </div>
                </div>

                <fieldset v-if="displayPlz()">
                    <label>{{ trans('crm-Postleitzahl') }}</label>
                    <div class="row">
                        <div class="col">
                            <input name="plz" id="plz" type="text"
                                   v-bind:placeholder="trans('crm-bitte_eintragen')"
                                   v-model="plz"
                                   @focusin="onFocusPlz"
                                   v-bind:class="{'has-geocoordinates': plzContainsGeocoordinates, 'has-error': showErrors() && plzError}"
                                   v-bind:tabindex="plzContainsGeocoordinates ? -1 : 0"
                                   required="required"
                            />
                            <div id="btn-location" title="verwenden Sie Ihren aktuellen Standort für die Suche."
                                 @click="onClickPlzLocation"
                                 v-bind:class="{enabled: isGeolocationAvailable}"
                            ></div>
                        </div>
                    </div>
                </fieldset>

                <fieldset v-if="displaySuchebutton()">
                    <div class="row justify-content-end">
                        <div class="col-auto">
                            <button type="submit" class="button schwarz" :disabled="isSucheMoeglich() === false">
                                {{ trans('crm-suche_starten') }}
                            </button>
                        </div>
                    </div>
                </fieldset>
            </form>
        </div>
    </div>

    <div class="errors" v-if="showErrors()">
        <div class="row justify-content-center">
            <div class="col-12 col-md-10 col-lg-8">
                <div class="error-box" v-if="plzError">{{ trans('crm-Postleitzahl-Error') }}</div>
            </div>
        </div>
    </div>

    <div class="ergebnisse"
         v-if="!b_working && (adressenErgebnis.length > 0 || adressenErgebnisHtml.length > 0)"
         :class="[b_working ? 'working' : '', ergebnisseClass]"
    >
        <div class="waiting"></div>
        <karte v-if="displayKarte()"
               :suchinteresse_id="suchinteresse_id"
               :adressenErgebnis="adressenErgebnis"
               :adressenSerien="adressenSerien"
        ></karte>

        <!-- Serverside Rendering -->
        <div v-html="adressenErgebnisHtml"></div>

    </div>

</template>

<script>

export {default} from './bezugsquellen.js';

</script>
